import { createSelector } from 'reselect';
import { isListingFurnished } from 'ha/models/ListingFacilities/isListingFurnished';
import { getFacilities } from '../reducer';

const getIsListingFurnished = createSelector([getFacilities], facilities =>
  isListingFurnished({ facilities }),
);

export { getIsListingFurnished };
